import { getStorage, connectStorageEmulator, Storage } from '@angular/fire/storage';
import { STORAGE_BUCKET } from '../state-management/constants/global.constants';

export function storageFactory(): () => Storage {
  return () => {
    const storage = getStorage(undefined, STORAGE_BUCKET);
    // if ('useEmulators' in environment && environment.useEmulators) {
    //   connectStorageEmulator(storage, 'localhost', 9199);
    // }
    return storage;
  };
}
